<template>
  <FormFieldWrapper :data="data">
    <input
      :value="modelValue"
      type="time"
      class="time-input"
      @input="handleInput"
      @blur="handleBlur"
    />
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'Time',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: ''
    },
    customValidation: {
      type: Function,
      default: null
    }
  },
  emits: ['update:modelValue', 'blur', 'validation-error'],
  methods: {
    handleInput(event) {
      this.$emit('update:modelValue', event.target.value);
    },
    handleBlur(event) {
      const value = event.target.value;
      if (this.customValidation) {
        const error = this.customValidation(value);
        if (error) {
          this.$emit('validation-error', error);
        }
      }
      this.$emit('blur', value);
    }
  }
};
</script>

<style scoped>
.time-input {
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #333;
  outline: none;
  transition: border-color 0.2s;
}

.time-input:focus {
  border-color: #004879;
}

.time-input:disabled {
  background: #F5F5F5;
  cursor: not-allowed;
}
</style>
